import { render, staticRenderFns } from "./ProviderLabel2FA.vue?vue&type=template&id=915cd300&scoped=true&"
import script from "./ProviderLabel2FA.vue?vue&type=script&lang=js&"
export * from "./ProviderLabel2FA.vue?vue&type=script&lang=js&"
import style0 from "./ProviderLabel2FA.vue?vue&type=style&index=0&id=915cd300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915cd300",
  null
  
)

export default component.exports